import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { MatTabChangeEvent, MatDialog } from '@angular/material';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { VisitDetailsComponent } from 'src/app/ChildControls/visit-details/visit-details.component';
import { IEncounterData } from 'src/app/models/IEncounterData';
import { PatientBannerService } from 'src/app/patient-banner/patient-banner.service';
// import { ConsentformsComponent } from '../encounter-note/consentforms/consentforms.component';

@Component({
  selector: 'app-or-note-header',
  templateUrl: './or-note-header.component.html',
  styleUrls: ['./or-note-header.component.css']
})

export class OrNoteHeaderComponent implements OnInit {
  isSidebar: boolean = false;
  @Input() oractivetab = 1;
  @Output() tabClicked = new EventEmitter<any>();
  //isSignOff: any;
  @Output() valueChange = new EventEmitter();
  visitNoteStatus: any;
  postFollowupVisibility: boolean;
  public encounterId: string;
  public isSignOff: boolean = false;
  public signoffEnc: IEncounterData;
  isSilderbarAlert: boolean = false;
  isSilderbarDocuments: boolean = false;
  private _opened: boolean = false;
  _openedDocuments: boolean = false;
  _openedAlerts: boolean = false;
  Isdocument: boolean = false;

  constructor(//private app: AppComponent,
    private route: ActivatedRoute, public dialog: MatDialog,
    private router: Router, private sharedService: SharedService
    , private bannerService: PatientBannerService) {
    //app.isLoggedIn$ = true;
    this.postFollowupVisibility = (sessionStorage.getItem("postFollowupVisibility") == "True");
    this.getSystem();
    this.encounterId = CommonComponents.encounterId;
    this.isSignedoff();
  }

  ngOnInit() {
    this.visitNoteStatus = CommonComponents.visitNoteStatus;
  }


  onLinkClick(event: MatTabChangeEvent) {
    this.tabClicked.emit(event);
  }

  getSystem() {
    if (sessionStorage.getItem("encounterid") != null || sessionStorage.getItem("encounterid") != undefined) {
      CommonComponents.encounterId = sessionStorage.getItem("encounterid");
    }
  }

  getVisitDetails(): void {
    const dialogRef = this.dialog.open(VisitDetailsComponent, {
      width: '800px',
      height: '100%',
      data: { signOff: this.isSignOff }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  isSignedoff() {
    if (sessionStorage.getItem("encounterid") != null && sessionStorage.getItem("encounterid") != undefined) {
      this.sharedService.getIsORSignedoff(sessionStorage.getItem("encounterid"), 2).subscribe(data => {
        this.isSignOff = data;
      });
    }
  }

  public _toggleSidebar(event) {
    // this.isSidebar = true;
    // // this.isSidebar = false;
    // this.isSilderbarAlert = false;
    // this._opened = false;
    // this.isSilderbarDocuments = false;
    // this._openedDocuments = false;
    // this._openedAlerts = false;

    this.isSidebar = true;
    this.isSilderbarAlert = false;
    this._opened = !this._opened;
    this.isSilderbarDocuments = false;
    this._openedDocuments = false;
    this._openedAlerts = false;
  }
  onClickCancel() {
    sessionStorage.removeItem("patientId");
    sessionStorage.removeItem("patientName");
    localStorage.removeItem("isBackBtnVisibleInVisitNotes");
    var displayDate = sessionStorage.getItem("displayappDate");
    sessionStorage.setItem("displayDate", displayDate);
    CommonComponents.patientId = 0;
    CommonComponents.patientName = '';
    this.bannerService.toggle(Number("-1"));
    this.router.navigate(["Appointments"]);
  }
  displayRenderingProviderORNoteHeader(event) {
    this.valueChange.emit(event);
  }
  isSidebars: boolean = false;
  showAlerts: boolean = false;
  public _AlertSidebar(event) {
    this.isSidebars = false;
    this.isSidebar = false;
    this.isSilderbarAlert = true;
    this.isSilderbarDocuments = false;
    this._openedAlerts = !this._openedAlerts;
    this._opened = false;
    this._openedDocuments = false;
    this.showAlerts = true;
    sessionStorage.setItem("visitNoteAlertsheaderVisibility", "false");
    // sessionStorage.setItem("AlertsheaderIconVisibility", "true");
    sessionStorage.setItem("AlertsheaderIconVisibility", "true");
  }
  closeAlerts() {
    this._openedAlerts = !this._openedAlerts;
  }
  public DocumentsSidebar(event) {
    sessionStorage.setItem("fromscreen", "visitdocument");
    this.isSidebars = false;
    this.isSidebar = false;
    this._openedDocuments = !this._openedDocuments;
    this.isSilderbarAlert = false;
    this.isSilderbarDocuments = true;
    this._openedAlerts = false;
    sessionStorage.setItem("hideDocumentsHeader", "true");
    this.Isdocument = true;
  }
  closeDocuments() {
    this._openedDocuments = false;
    this.Isdocument = false;
  }
  public _toggleSidebarVisitInfo(event) {
    this.isSidebar = true;
    // this.isSidebar = false;
    this.isSilderbarAlert = false;
    this._opened = !this._opened;
    this.isSilderbarDocuments = false;
    this._openedDocuments = false;
    this._openedAlerts = false;
  }
}
